import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "familyFilled"
const FamilyFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M5.625 14.25C6.661 14.25 7.5 15.09 7.5 16.125S6.66 18 5.625 18 3.75 17.16 3.75 16.125 4.59 14.25 5.625 14.25M18 14.25C19.035 14.25 19.875 15.09 19.875 16.125S19.035 18 18 18 16.125 17.16 16.125 16.125 16.965 14.25 18 14.25" />
          <path
            fillRule="evenodd"
            d="M10.5 7.313C13.536 7.313 16.465 8.436 18.721 10.467L19.047 10.761 21.217 11.575C21.808 11.795 22.22 12.325 22.298 12.938H21.75C21.44 12.938 21.188 13.189 21.188 13.5 21.188 13.81 21.439 14.063 21.75 14.063H22.313V15.75C22.313 16.268 21.893 16.688 21.375 16.688H20.564Q20.624 16.415 20.625 16.125C20.625 14.675 19.45 13.5 18 13.5S15.375 14.675 15.375 16.125Q15.376 16.415 15.437 16.688H8.188Q8.25 16.415 8.25 16.125C8.25 14.675 7.075 13.5 5.625 13.5S3 14.675 3 16.125Q3.001 16.415 3.062 16.688H2.625C2.107 16.688 1.688 16.267 1.688 15.75V13.688H2.625C2.935 13.688 3.188 13.436 3.188 13.125S2.936 12.563 2.625 12.563H1.688V11.478L1.926 11.053 2.668 8.327C2.53 8.225 2.438 8.06 2.438 7.875 2.438 7.565 2.689 7.313 3 7.313zM3.187 10.7 4.687 10.69V8.436H3.806zM5.813 10.687H9.938V8.438H5.812zM11.063 10.688H17.22C15.44 9.346 13.296 8.564 11.063 8.452z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default FamilyFilledIcon
